module.exports = FormData;


//////////////////
// WEBPACK FOOTER
// ./~/isomorphic-form-data/lib/browser.js
// module id = 737
// module chunks = 0